import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function CitiesGrid() {
  const [cities, setCities] = useState([]);
  useEffect(() => {
    api.get("/cities").then(({ data }) => setCities(data)).catch(() => setCities([]));
  }, []);

  if (cities.length === 0) return null;

  return (
    <section className="py-24 bg-[#F2EBE1] border-t border-border" data-testid="cities-grid">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#786B63]">By city</p>
            <h2 className="font-serif text-4xl sm:text-5xl mt-3 leading-tight">
              Where to find the good stuff.
            </h2>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cities.map((c) => (
            <Link
              key={c.slug}
              to={`/city/${c.slug}`}
              data-testid={`city-card-${c.slug}`}
              className="cafe-card group block border border-border bg-card overflow-hidden rounded-sm hover:-translate-y-1 transition-transform"
            >
              <div className="aspect-[5/4] overflow-hidden bg-[#E8DFD3]">
                {c.image_url && (
                  <img
                    src={c.image_url}
                    alt={c.name}
                    loading="lazy"
                    className="cafe-card-image w-full h-full object-cover"
                  />
                )}
              </div>
              <div className="p-5 flex items-center justify-between">
                <div>
                  <h3 className="font-serif text-2xl leading-tight">{c.name}</h3>
                  <p className="text-xs text-[#786B63] mt-1 uppercase tracking-wider">
                    {c.count} {c.count === 1 ? "spot" : "spots"}
                  </p>
                </div>
                <ArrowRight className="h-4 w-4 text-[#C05A46]" strokeWidth={1.5} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
